// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2eQkl","label":"LabeledBox_label__3hjYF"};